<template>
	<span class="classification_pill"
		:class="[`classification_pill_${slug}`, `classification_pill_${size}`]">
		{{ label }}
	</span>
</template>

<script>
// Pill transversal del MODO DE CLASIFICACIÓN de una contraparte
// (classify_by_counterpart: Contraparte / Documento / Mixta / Sin Clasificar).
// Fuente única de color + label, para que la clasificación, el detalle de
// cliente y el modal de clasificación se lean igual. El color sale de los tokens
// `--classification-<slug>-*` (`:root`, _report_themes.scss). A diferencia de
// <CounterpartTypePill>, NO lleva ícono — la clasificación es sólo color.
// Genérico: sin Vuex, sólo props.
//
// Label verboso (labelStyle="verbose") centralizado acá — antes vivía duplicado
// en HeaderClientDetail (CLASSIFICATION_LABELS) y ClassifyAccountAttributes
// (localClassificationType).
const VERBOSE_LABELS = Object.freeze({
	Contraparte: "Clasificación por Contraparte",
	Documento: "Clasificación por Documento",
	Mixta: "Clasificación Mixta",
});

export default {
	name: "ClassificationPill",
	props: {
		// Valor crudo del backend ("Contraparte", "Documento", "Mixta",
		// "Sin Clasificar"). Define el color y, en modo raw, el label.
		value: { type: String, required: true },
		// "raw" (default) → el valor tal cual ("Contraparte"); "verbose" → el
		// label largo ("Clasificación por Contraparte"). Sin entrada verbose
		// (p.ej. Sin Clasificar) cae al valor crudo.
		labelStyle: {
			type: String,
			default: "raw",
			validator: (v) => ["raw", "verbose"].includes(v),
		},
		// Tamaño según contexto: "sm" (12px, tablas — default), "lg" (14px,
		// header del drawer), "xl" (20px, modal de clasificación).
		size: {
			type: String,
			default: "sm",
			validator: (v) => ["sm", "lg", "xl"].includes(v),
		},
	},
	computed: {
		// Slug → clase de color. "Sin Clasificar" → "sin_clasificar".
		slug() {
			return String(this.value || "").trim().toLowerCase().replace(/\s+/g, "_");
		},
		label() {
			if (this.labelStyle === "verbose") {
				return VERBOSE_LABELS[this.value] ?? this.value;
			}
			return this.value;
		},
	},
};
</script>

<style lang="scss" scoped>
.classification_pill {
	display: inline-flex;
	align-items: center;
	padding: 2px 8px;
	border-radius: 999px;
	border: 1px solid transparent;
	font-size: 12px;
	font-weight: 500;
	line-height: 18px;
	white-space: nowrap;
}

// Tamaños por contexto (mismo sistema que CounterpartTypePill, para que ambas
// familias de pill se lean coherentes). "sm" usa los valores base.
.classification_pill_lg {
	font-size: 14px;
	padding: 2px 10px;
	border-radius: 12px;
}

.classification_pill_xl {
	font-size: 20px;
	padding: 4px 12px;
	border-radius: 16px;
}

// Color por modo de clasificación desde los tokens transversales (:root).
.classification_pill_contraparte { background: var(--classification-contraparte-bg); color: var(--classification-contraparte-text); border-color: var(--classification-contraparte-border); }
.classification_pill_documento { background: var(--classification-documento-bg); color: var(--classification-documento-text); border-color: var(--classification-documento-border); }
.classification_pill_mixta { background: var(--classification-mixta-bg); color: var(--classification-mixta-text); border-color: var(--classification-mixta-border); }
.classification_pill_sin_clasificar { background: var(--classification-sin_clasificar-bg); color: var(--classification-sin_clasificar-text); border-color: var(--classification-sin_clasificar-border); }
</style>
